import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  min-height: 100dvh;
  width: 100vw;
  overflow: auto;
  z-index: 10000;
  background: var(--color-page);

  .header-wrapper {
    width: 100% !important;
  }

  .content {
    width: min(540px, 100%);
    padding: 24px 16px;
    min-height: calc(100dvh - 96px);
    margin: 0 auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    grid-gap: 40px;

    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    text-align: center;
    color: var(--color-text);

    h2 {
      font-weight: 600;
      font-size: 18px;
      line-height: 150%;
      text-align: center;
      text-transform: capitalize;
      color: var(--color-text-muted);
      margin: 0;
    }

    .button {
      width: 150px;
    }

    .text {
      max-width: 350px;
    }

    .signInButton {
      display: flex;
      align-items: center;

      .signLink {
        cursor: pointer;
        text-decoration: underline;
        font-weight: 500;
        font-size: 16px;
        line-height: 100%;
        color: var(--color-text-muted);
      }
    }

    .positive-icon {
      width: 100px;
      height: 100px;
      color: var(--color-accent);
    }

    .positive-icon__external-circle {
      fill-opacity: 0.1;
    }

    .positive-icon__internal-circle {
      fill-opacity: 0.2;
    }

    svg {
      color: var(--color-fixed-tint);
    }
  }
`;
